import { el, clear, debounce } from '../../utils/dom.js';
import { Reservations } from '../../api/resources.js';
import { dataTable } from '../../components/table.js';
import { statusBadge } from '../../components/badge.js';
import { fmtDateTime } from '../../utils/format.js';
import { ok, err } from '../../components/toast.js';

const STATUSES = ['', 'pendiente','confirmada','cancelada','vencida','convertida_prestamo','convertida_renta'];

export default async function ReservationsListPage(outlet) {
  clear(outlet);
  const state = { page: 1, q: '', status: '' };

  outlet.appendChild(el('div', { class: 'page-head' },
    el('h1', {}, 'Reservas'),
    el('div', { class: 'flex gap-2' },
      el('a', { href: '#/reservations/calendar', class: 'btn' }, '📅 Calendario'),
      el('button', { class: 'btn', onclick: async () => {
        try { const r = await Reservations.sweepExpired(); ok(`${r.updated_count} expiradas`); refresh(); }
        catch (ex) { err(ex.message); }
      } }, 'Vencer pendientes'),
      el('a', { href: '#/reservations/new', class: 'btn primary' }, '+ Nueva reserva'),
    ),
  ));

  const search = el('input', { class: 'input grow', placeholder: 'Buscar...',
    oninput: debounce((e) => { state.q = e.target.value; state.page = 1; refresh(); }, 300) });
  const statusSel = el('select', { class: 'select', onchange: (e) => { state.status = e.target.value; state.page = 1; refresh(); } },
    ...STATUSES.map((s) => el('option', { value: s }, s || 'Todo estado')));
  outlet.appendChild(el('div', { class: 'toolbar' }, search, statusSel));

  const host = el('div');
  outlet.appendChild(host);

  async function refresh() {
    host.innerHTML = '<div class="empty">Cargando...</div>';
    try {
      const res = await Reservations.list({ page: state.page, limit: 25, q: state.q || undefined, status: state.status || undefined });
      host.replaceChildren(dataTable({
        columns: [
          { key: 'code',   label: 'Codigo',   render: (r) => el('a', { href: `#/reservations/${r.id}`, class: 'text-mono text-bold' }, r.code) },
          { key: 'cliente', label: 'Para',    render: (r) => r.client_name || r.responsible_name || '—' },
          { key: 'status', label: 'Estado',   render: (r) => statusBadge(r.status) },
          { key: 'start_date', label: 'Inicio', render: (r) => fmtDateTime(r.start_date) },
          { key: 'end_date',   label: 'Fin',    render: (r) => fmtDateTime(r.end_date) },
          { key: 'expires_at', label: 'Expira', render: (r) => r.expires_at ? fmtDateTime(r.expires_at) : '—' },
        ],
        rows: res.data || [],
        empty: 'Sin reservas.',
        pagination: res.pagination ? { page: res.pagination.page, pages: res.pagination.pages, onPage: (p) => { state.page = p; refresh(); } } : null,
      }));
    } catch (ex) {
      host.innerHTML = `<div class="empty">Error: ${ex.message}</div>`;
    }
  }
  refresh();
}
